/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const env = (typeof process !== 'undefined') ? process.env : {};
    
const sitecoreApiKey = env.VUE_APP_SITECORE_API_KEY || "{A95EEBE9-705D-4493-8E8F-A0F2CF581C8F}";
const sitecoreApiHost = env.VUE_APP_SITECORE_API_HOST || "http://localhost";
const jssAppName = env.VUE_APP_JSS_APP_NAME || "echoparkjss";
const layoutServiceConfigurationName = env.VUE_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "jss";
const deployedEnv = env.VUE_APP_DEPLOYED_ENV || "true";
const defaultLanguage = env.VUE_APP_DEFAULT_LANGUAGE || "en";
const graphQLEndpointPath = env.VUE_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge";
const graphQLEndpoint = env.VUE_APP_GRAPH_QL_ENDPOINT || `${sitecoreApiHost}${graphQLEndpointPath}`;
const config = {
   sitecoreApiKey,
   sitecoreApiHost,
   jssAppName,
   layoutServiceConfigurationName,
   deployedEnv,
   defaultLanguage,
   graphQLEndpointPath,
   graphQLEndpoint,
};
export default config;